import(/* webpackMode: "eager" */ "/vercel/path0/app/calendar/page.tsx");
